export const HIGHEST_OI_GAINERS_LOSERS = "HIGHEST_OI_GAINERS_LOSERS";
export const HIGHEST_OI_GAINERS_LOSERS_STREAM = "HIGHEST_OI_GAINERS_LOSERS_STREAM";
export const HIGHEST_OI_LAST_UPDATED_TIME = "HIGHEST_OI_LAST_UPDATED_TIME";
